import React from 'react';
import './withUniResizableColumn.css';
const withUniResizableColumn = (Component) => {
  type Props = {
    widthOfCol: number,
    setColWidth: function,
    minWidth: number,
    maxWidth: number
  };
  type State = {
    widthOfColumn: number,
    withinResizingArea: boolean,
    resize: boolean,
    resizeLinePosition: object,
    initialResizeLinePosition: number,
    lastResizingLinePosition: number,
    changeInColumnWidth: number
  };
  return class withUniResizableColumn extends React.Component<Props, State> {
    constructor(props) {
      super(props);
      this.state = {
        widthOfColumn: props.widthOfCol,
        withinResizingArea: false,
        resize: false,
        resizeLinePosition: {},
        initialResizeLinePosition: 0,
        lastResizingLinePosition: 0,
        changeInColumnWidth: 0
      };
    }

    componentDidMount() {
      document.addEventListener('mouseup', this.onMouseUpForDoneResize);
      document.addEventListener('mousemove', this.onMouseMoveForResize);
    }

    componentWillUnmount() {
      document.removeEventListener('mouseup', this.onMouseUpForDoneResize);
      document.removeEventListener('mousemove', this.onMouseMoveForResize);
    }

    setClassNameOfCol = (classNameOfCol) => {
      this.setState({ classNameOfCol });
    };

    setChangeInColumnWidth = (changeInColumnWidth) => {
      this.setState({ changeInColumnWidth });
    };

    setInitialResizeLinePosition = (initialResizeLinePosition) => {
      this.setState({ initialResizeLinePosition });
    };

    setLastResizingLinePosition = (lastResizingLinePosition) => {
      this.setState({ lastResizingLinePosition });
    };

    setWithinResizingArea = (withinResizingArea) => {
      this.setState({ withinResizingArea });
    };

    setresize = (resize) => {
      this.setState({ resize });
    };

    setResize = (resize) => {
      this.setState({ resize });
    };

    setResizeLinePosition = (resizeLinePosition) => {
      this.setState({ resizeLinePosition });
    };

    onMouseMoveForResize = (e: MouseEvent) => {
      const { resize } = this.state;
      const { minWidth, maxWidth } = this.props;
      if (resize && e.clientX <= maxWidth && e.clientX >= minWidth) {
        this.setResizeLinePosition({ left: e.clientX });
      }
    };

    onMouseEnterForResize = (e: MouseEvent) => {
      document.body.style.cursor = 'col-resize';
      this.setWithinResizingArea(true);
    };

    onMouseLeaveForResize = (e: MouseEvent) => {
      const { resize } = this.state;
      if (!resize) {
        this.setWithinResizingArea(false);
        document.body.style.cursor = 'default';
      }
    };

    onMouseDownForResize = (e: MouseEvent) => {
      const { withinResizingArea } = this.state;
      if (withinResizingArea) {
        this.setresize(true);
        this.setResizeLinePosition({ left: e.clientX });
        this.setInitialResizeLinePosition(e.clientX);
      }
    };

    onMouseUpForDoneResize = (e: MouseEvent) => {
      const { resize, initialResizeLinePosition } = this.state;
      if (resize) {
        const lastResizingLinePosition = e.clientX;
        this.setresize(false);
        this.setLastResizingLinePosition(lastResizingLinePosition);
        this.setChangeInColumnWidth(lastResizingLinePosition - initialResizeLinePosition);
        this.updateColumnWidth();
      }
      document.body.style.cursor = 'default';
    };

    nullifyDragEvent = (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
    };

    updateColumnWidth = (e: MouseEvent) => {
      const { changeInColumnWidth } = this.state;
      const { widthOfCol, setColWidth, minWidth, maxWidth } = this.props;
      const newWidth = Math.abs(changeInColumnWidth + widthOfCol);
      if (newWidth < minWidth) setColWidth(minWidth);
      else if (newWidth > maxWidth) setColWidth(maxWidth);
      else setColWidth(newWidth);
    };

    render() {
      const { resize, resizeLinePosition } = this.state;
      return (
        <div name="withUniResizableColumn" className="uni-resize-col-container flex-row">
          <Component {...this.props}></Component>
          <div
            className="uni-resizer"
            onMouseEnter={this.onMouseEnterForResize}
            onMouseLeave={this.onMouseLeaveForResize}
            onMouseDown={this.onMouseDownForResize}
            onDragStart={this.nullifyDragEvent}></div>
          {resize ? (
            <div>
              <div className="transparent-background uni-resize-bg" />
              <div className="uni-resize-seperator" style={resizeLinePosition}></div>
            </div>
          ) : null}
        </div>
      );
    }
  };
};
export default withUniResizableColumn;
